import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function Menu() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(
    Boolean(localStorage.getItem('visible'))
  );
  const Logout = () => {
    localStorage.removeItem('DM_Admin_ID');
    localStorage.removeItem('DM_Admin_EMAIL');
    localStorage.removeItem('DM_Admin_NAME');
    localStorage.removeItem('DM_Admin_IMAGE');
    localStorage.removeItem('DM_Admin_TOKEN');
    navigate('/teleport-admin');
    toast.success('!Logout Successfully');
  };

  var dashboardClass = window.location.pathname.match(/^\/dashboard/)
    ? 'active'
    : '';

  var userListClass =
    window.location.pathname.match(/^\/users-list/) ||
      window.location.pathname.match(/^\/users-details/)
      ? 'active'
      : '';
  var driversListClass =
    window.location.pathname.match(/^\/drivers-list/) ||
      window.location.pathname.match(/^\/drivers-details/)
      ? 'active'
      : '';

  var jobsListClass =
    window.location.pathname.match(/^\/jobs-list/) ||
      window.location.pathname.match(/^\/jobs-details/)
      ? 'active'
      : '';

  var claimRequestClass =
    window.location.pathname.match(/^\/claim-request-list/)
      ? 'active'
      : '';

  var PayoutRequestClass = window.location.pathname.match(/^\/payout-request-list/)
    ? 'active'
    : '';

  var promoCodeClass =
    window.location.pathname.match(/^\/promo-code/) ? 'active' : '';

  var cmsClass = window.location.pathname.match(/^\/cms-management/)
    ? 'active'
    : '';

  useEffect(() => {
    if (!localStorage.getItem('DM_Admin_TOKEN')) {
      toast.error('!..Please login first');
      navigate('/teleport-admin');
    }
  }, []);
  // useEffect(() => {
  //   localStorage.getItem("visible")
  //     ? localStorage.setItem("visible", visible)
  //     : localStorage.setItem("visible", false);
  // }, [visible]);

  return (
    <>
      <div id="header" className="header navbar-default">
        <div className="navbar-header">
          <NavLink to="/dashboard" className="navbar-brand ">
            <img
              src="/assets/img/logo/Vector.png"
              alt="Chef-event-logo"
              className="d-inline-block align-text-top mr-2"
            />
            <span className="logo"></span>
            <span className="BrudAdmin">
              <b>Teleport</b>
            </span>
          </NavLink>

          <button
            type="button"
            className="navbar-toggle"
            data-click="sidebar-toggled"
          >
            <span className="icon-bar" style={{ color: '#fff' }}></span>
            <span className="icon-bar" style={{ color: '#fff' }}></span>
            <span className="icon-bar" style={{ color: '#fff' }}></span>
          </button>
        </div>

        <ul className="navbar-nav navbar-right admin">
          <li className="dropdown navbar-user">
            <a href="#" className="dropdown-toggle" data-toggle="dropdown">
              <img src={localStorage.getItem('DM_Admin_IMAGE')} alt="" />
              <span className="d-none d-md-inline userName">
                {localStorage.getItem('DM_Admin_NAME')}
              </span>{' '}
              <b className="caret"></b>
            </a>
            <div
              className="dropdown-menu dropdown-menu-right"
              style={{ borderRadius: '20px', padding: '5px ' }}
            >
              <NavLink
                to="/admin-profile"
                style={{ textDecoration: 'none', color: '#404252' }}
              >
                <span className="dropdown-item">
                  <span className="DropdownItem">Edit Profile</span>
                </span>
              </NavLink>
              <span className="dropdown-item" onClick={Logout}>
                <span className="DropdownItem">
                  <span className="DropdownItem ml-0">Log Out</span>
                </span>
              </span>
            </div>
          </li>
        </ul>
      </div>

      <div id="sidebar" className="sidebar">
        <div data-scrollbar="true" data-height="100%">
          <div className="nav-header"></div>
          <ul className="nav">
            <li className="sidebarList">
              <NavLink
                to="/dashboard"
                className={dashboardClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <i className="fa fa-th-large menuIcon"></i>
                  <span className="menuItem">Dashboard</span>
                </div>
              </NavLink>
            </li>

            <li className="sidebarList">
              <NavLink
                to="/users-list"
                className={userListClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <i className="fa fa-users menuIcon"></i>
                  <span className="menuItem">Users</span>
                </div>
              </NavLink>
            </li>
            <li className="sidebarList">
              <NavLink
                to="/drivers-list"
                className={driversListClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  {/* <i class="fa fa-hat-chef menuIcon"></i> */}
                  <i class="fa fa-user-tie menuIcon"></i>
                  <span className="menuItem">Drivers</span>
                </div>
              </NavLink>
            </li>

            <li className="sidebarList">
              <NavLink
                to="/jobs-list"
                className={jobsListClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  {/* <i class="fa fa-hat-chef menuIcon"></i> */}
                  <i class="fa fa-tasks menuIcon"></i>
                  <span className="menuItem">Jobs</span>
                </div>
              </NavLink>
            </li>
            <li className="sidebarList">
              <NavLink
                to="/claim-request-list"
                className={claimRequestClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  {/* <i class="fa fa-hat-chef menuIcon"></i> */}
                  <i class="fa fa-list menuIcon"></i>
                  <span className="menuItem">Claim Requests</span>
                </div>
              </NavLink>
            </li>

            <li className="sidebarList">
              <NavLink
                to="/promo-code"
                className={promoCodeClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <i className="fa fa-gift menuIcon"></i>
                  <span className="menuItem">Promo Code</span>
                </div>
              </NavLink>
            </li>

            <li className="sidebarList">
              <NavLink
                to="/payout-request-list"
                className={PayoutRequestClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  {/* <i class="fa fa-hat-chef menuIcon"></i> */}
                  <i class="fa fa-comments-dollar menuIcon"></i>
                  <span className="menuItem">Payout</span>
                </div>
              </NavLink>
            </li>


            <li className="sidebarList">
              <NavLink
                to="/cms-management"
                className={cmsClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <i class="fa fa-clipboard-check menuIcon"></i>
                  <span className="menuItem">CMS Mngt</span>
                </div>
              </NavLink>
            </li>


            {/* <li className="sidebarList">
              <NavLink
                to="/events"
                className={eventListClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <EventIcon
                    className="menuIcon"
                    style={{ fontSize: '20px', marginTop: '-4px' }}
                  />
                  <span className="menuItem">Event</span>
                </div>
              </NavLink>
            </li>
            <li className="sidebarList">
              <NavLink
                to="/billing"
                className={billingClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <i class="fa fa-money-bill menuIcon"></i>
                  <span className="menuItem">Billing</span>
                </div>
              </NavLink>
            </li>
            <li className="sidebarList">
              <NavLink
                to="/booking"
                className={bookingClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <CollectionsBookmarkIcon
                    className="menuIcon"
                    style={{ fontSize: '20px', marginTop: '-4px' }}
                  />
                  <span className="menuItem">Booking</span>
                </div>
              </NavLink>
            </li>
            <li className="sidebarList">
              <NavLink
                to="/feedback"
                className={feedbackClass}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <FeedbackIcon
                    className="menuIcon"
                    style={{ fontSize: '20px', marginTop: '-4px' }}
                  />
                  <span className="menuItem">Feedback</span>
                </div>
              </NavLink>
            </li>
            <li className="sidebarList">
              <NavLink
                to="/terms-and-conditions"
                className={TandC}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <i className="menuIcon">
                    <GavelIcon
                      style={{ fontSize: '20px', marginTop: '-4px' }}
                    />
                  </i>
                  <span className="menuItem">T & C</span>
                </div>
              </NavLink>
            </li>
            <li className="sidebarList">
              <NavLink
                to="/privacy-policy"
                className={pp}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <i className="menuIcon">
                    <PolicyIcon
                      style={{ fontSize: '20px', marginTop: '-4px' }}
                    />
                  </i>
                  <span className="menuItem">Policy</span>{' '}
                </div>
              </NavLink>
            </li>
            <li className="sidebarList">
              <NavLink
                to="/about-us"
                className={aboutus}
                activeClassName="active"
              >
                <div className="menuItemDiv">
                  <i className="menuIcon">
                    <InfoIcon style={{ fontSize: '20px', marginTop: '-4px' }} />
                  </i>
                  <span className="menuItem">AboutUs</span>
                </div>
              </NavLink>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
}

export default Menu;
